// src/redux/store.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import commonReducer from './slices/commonSlice';
import usersReducer from "./slices/Users/slice"
import propertyTypeReducer from "./slices/PropertyType/slice"
import areaReducer from "./slices/AreaManagement/slice"
import propertiesForSaleReducer from "./slices/propertiesForSale/slice"
import propertyManagementReducer from "./slices/PropertyManagement/slice"
import streetReducer from "./slices/StreetManagement/slice"
import agentInteractionsReducer from "./slices/agentInteractions/slice"



const store = configureStore({
  reducer: {
    auth: authReducer,
    common:commonReducer,
    users:usersReducer,
    propertyType:propertyTypeReducer,
    area:areaReducer,
    propertiesForSale:propertiesForSaleReducer,
    propertyManagement:propertyManagementReducer,
    street:streetReducer,
    agentInteractions:agentInteractionsReducer
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
